/* eslint-disable */

import { _ } from 'vue-underscore';

export function executeAfterTwoSeconds(action) {
    return _.throttle(action, 2000, { leading: false, trailing: true });
}

export function normalizeArrayOfCcm(ccms, extraNormalize) {

    if (!Array.isArray(ccms))
        throw new Error('Server response must be array');

    return ccms.map(ccm => {
        if (ccm.creationDate != null)
            ccm.creationDate = new Date(ccm.creationDate);

        if (ccm.openingDate != null)
            ccm.openingDate = new Date(ccm.openingDate);

        if (ccm.closingDate != null)
            ccm.closingDate = new Date(ccm.closingDate);

        if (ccm.blockingDate != null)
            ccm.blockingDate = new Date(ccm.blockingDate);

        if (ccm.ofdBlockingDate != null)
            ccm.ofdBlockingDate = new Date(ccm.ofdBlockingDate);

        if (extraNormalize != null)
            extraNormalize(ccm);

        return ccm;
    });
}

export function normalizeReports(reports) {
    if (!Array.isArray(reports))
        throw new Error('Server must be returns array');

    return reports.map(x => {
        if (x.creationDate != null)
            x.creationDate = new Date(x.creationDate);

        if (x.fromDate != null)
            x.fromDate = new Date(x.fromDate);

        if (x.tillDate != null)
            x.tiilDate = new Date(x.tiilDate);

        return x;
    });
}

export function getEndOfCurrentDay() {
    const date = new Date();
    date.setHours(23, 59, 59, 59, 999);

    return date;
}

export const DateRangeType = {
    LastHour: 'LastHour',
    Last12Hours: 'Last12Hours',
    LastDay: 'LastDay'
};

export function getDateRange(dateRangeType) {
    const start = new Date();
    const end = new Date();    

    switch (dateRangeType) {
        case DateRangeType.LastHour:
            start.setTime(start.getTime() - hoursToMilliseconds(1));
            break;
            
        case DateRangeType.Last12Hours:
            start.setTime(start.getTime() - hoursToMilliseconds(12));
            break;

        default:
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59, 59, 999);
            break;
        }

    return { 
        start,
        end
    };
}

function hoursToMilliseconds(hours) {
    return hours * 60 * 60 * 1000;
}

export function parseDate(dateTime) {
    if (dateTime instanceof Date)
        return dateTime;

    //todo: check date format
    if (typeof(dateTime) == "string")
        return new Date(dateTime);

    return null;
}